import React, { useState } from 'react';
import { SubMenu_CM } from './SubMenu_CM';
import t from '../../../i18n/I18n';
import { CONFLICT, MODIFIED, UPTODATE_NEEDED_ICON, VERSIONED } from '../../../util/Constants';
import CheckoutController from '../../../controllers/CheckoutController';
import Button from '../../Button';
import ToolTip, { AssetStatusView } from '../../AssetPropertyView';
import NativeActionUtil from '../../../util/NativeActionUtil';
import { filterAssets, getAssetProps } from '../../../util/SelectedItemUtil';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import System from '../../../basic/System';
import ViewUtil from '../../../ViewUtil';
import { Separator } from '../../form';
import "./StatusOption_CM.css";
import RightClickMenuTooltip from '../../../constants/RightClickMenuTooltip';
import classNames from 'classnames';
function StatusOption_CM(props) {
  const [isHover, setIsHover] = useState(false);
  const onHoverHandler = () => {
    setIsHover(true);
  }

  const onMouseLeave = () => {
    setIsHover(false);
  }
  const isAssetOrSearchTabActive = ViewUtil.isAssetTabActive() || ViewUtil.isSeachTabActive();
  const { assets, getProgressOnQuery, excludedActions, closeContextMenu, onOperationComplete } = props;
  const assetProps = getAssetProps(assets);
  const {containsDeleted, containsArchived, containsExpired, allFromWC, containsModified, containsConflict, containsPotentialConflict, containsUpdatePending, containWCFile} = assetProps;
  const containsNonAliveAsset = containsDeleted || containsArchived || containsExpired;
  const singleAsset = assets.length === 1 ? true : false
  const asset = assets[0];
  const items = [];
  let containToRefs = false;
  if (System.isVAB() && isAssetOrSearchTabActive) {
    if (singleAsset) {
      containToRefs = asset.isHasToLinks();
    }

    if (allFromWC) {
      const statusObject = asset.wcStatusObject;
      const modTime = statusObject && statusObject.getModTime() ? statusObject.getModTime() : '';
      const contextMenuStatusCheckIn = {
        menuStatus: t('CHECK_IN'),
        modStat: singleAsset
          ? t('MODIFIED_ON', { TIME: modTime })
          : containsModified
            ? t('CHECK_IN') + ' ' + t(MODIFIED) + ' ' + t('FILES')
            : ' '
      };
      const contextMenuStatusUpdate =
        containsConflict || containsPotentialConflict
          ? {
            menuStatus: t('CONFLICT_MENU'),
            modStat: containsPotentialConflict
              ? t('ACTION_DETECTED', {
                ACTION: 'Potential Conflict',
                TIME: modTime
              })
              : t('ACTION_DETECTED', { ACTION: 'Conflict', TIME: modTime })
          }
          : {
            menuStatus: containsUpdatePending ? t('UPDATE') : t('UP_TO_DATE'),
            modStat: !containsUpdatePending
              ? t('LAST_UPDATED', { TIME: modTime })
              : !singleAsset
                ? t('UPDATE') + ' ' + t('FILES')
                : undefined
          };
      if (containsConflict || containsPotentialConflict){
        items.push(getConflictMenu(contextMenuStatusUpdate, assets, isHover, closeContextMenu));
      } else if (
        containsUpdatePending ||
        !containsModified ||
        containsNonAliveAsset
      ) {
        containToRefs && containsUpdatePending && false
          ? items.push(
            <SubMenu_CM
              items={getExtraCheckoutUpdateOptions(assets, getProgressOnQuery, closeContextMenu)}
              key={1}
              isComponent={true}
              showCompomentAsLabel={true}
              Component={getUpdateMenu(contextMenuStatusUpdate, assets, assetProps, isHover, closeContextMenu)}
            />
          )
          : items.push(getUpdateMenu(contextMenuStatusUpdate, assets, assetProps, isHover, closeContextMenu));
      } else {
        items.push(
          <Button key={0} className="statusItem" onClick={() => onCheckInClick(assets, closeContextMenu)}>
            <AssetStatusView
              isNextLine={true}
              asset={asset}
              isContextMenu={true}
              contextMenuStatus={contextMenuStatusCheckIn}
              status={
                singleAsset ? statusObject._wcStatus : containsModified ? MODIFIED : VERSIONED
              }
              isHover={isHover}
            />
          </Button>
        );
      }

    } else if (!containWCFile && !containsNonAliveAsset) {
        containToRefs ? items.push(
          <SubMenu_CM
            items={getExtraCheckoutUpdateOptions(assets, getProgressOnQuery, closeContextMenu)}
            key={1}
            isComponent={true}
            showCompomentAsLabel={true}
            Component={getCheckoutMenu(assets, getProgressOnQuery, isHover, closeContextMenu)}
          />
        )
        : items.push(getCheckoutMenu(assets, getProgressOnQuery, isHover, closeContextMenu));
    }
  }

  const shouldOptionsClsApply =  allFromWC ? true : !containWCFile && !containsNonAliveAsset && !containToRefs ? true : false;
  return items.length > 0 ? <div name='status-option' className={classNames({'options': shouldOptionsClsApply})} onMouseOver={onHoverHandler} onMouseLeave={onMouseLeave}>{items}</div> : null;
}

export default StatusOption_CM;

const getConflictMenu = (contextMenuStatusObject, assets, isHover, closeContextMenu) => {
  return (
    <Button key={1} className="statusItem" onClick={() => onConflictResolveClick(assets, closeContextMenu)}>
      <AssetStatusView
        isNextLine={true}
        asset={assets[0]}
        isContextMenu={true}
        contextMenuStatus={contextMenuStatusObject}
        status={CONFLICT}
        isHover={isHover}
      />
    </Button>
  );
}

const getUpdateMenu = (contextMenuStatusUpdate, assets, assetProps, isHover, closeContextMenu) => {
  return (
    <Button key={1} className="statusItem" onClick={() => onUpdateClick(assets, closeContextMenu)}>
      <AssetStatusView
        isNextLine={true}
        asset={assets[0]}
        isContextMenu={true}
        contextMenuStatus={contextMenuStatusUpdate}
        isHover={isHover}
        status={
          assetProps.containsUpdatePending
            ? UPTODATE_NEEDED_ICON
            : VERSIONED
        }
      />
    </Button>
  );
}

const getExtraCheckoutUpdateOptions = (assets, getProgressOnQuery, closeContextMenu) => {
  const items = [];
  items.push(
    <div key={0}>
      <Button onClick={() => onCheckoutClick(true, false, assets, getProgressOnQuery, closeContextMenu)}
       title={RightClickMenuTooltip[t('WITH_LINKS')?.toLowerCase()]}
       text={t('WITH_LINKS')}
       />
    </div>
  );
  items.push(
    <div key={2}>
      <Button onClick={() => onCheckoutClick(false, true, assets, getProgressOnQuery, closeContextMenu)} 
      title={RightClickMenuTooltip[t('WITH_LINK_PROXY')?.toLowerCase()]}
      text={t('WITH_LINK_PROXY')}
      />
    </div>
  );
  items.push(
    <div key={3}>
      <Button onClick={() => onCheckoutClick(false, false, assets, getProgressOnQuery, closeContextMenu)}
      title={RightClickMenuTooltip[t('ONLY_CURRENT')?.toLowerCase()]}
      text={t('ONLY_CURRENT')} 
       />
    </div>
  );

  return items;
};

const getCheckoutMenu = (assets, getProgressOnQuery, isHover, closeContextMenu) => {
  const ToolTipLabel = RightClickMenuTooltip[t('CHECKOUT')?.toLowerCase()];
  return (
    <Button key={1} className="statusItem" onClick={() => onCheckoutClick(false, false, assets, getProgressOnQuery, closeContextMenu)}>
      <ToolTip
        text={ToolTipLabel}
        style={{padding: 0}}
        maxWidth={300}
      >
      <span>
        <img src={isHover ? ThemeSetup.getImageURL("hoverIcons/context/icons_checkout.svg") : "images/icons_checkout.svg"} style={{ marginBottom: '3px', padding: 'unset' }} />
      </span>
      <span style={{ paddingRight: '5px', marginLeft: '5px' }}>{t('CHECKOUT')}</span>
      <div className="mtimeWithStatus">
        <AssetStatusView isNextLine={true} asset={assets[0]} isContextMenu={true}/>
      </div>
      </ToolTip>
    </Button>
  );
};

const onCheckoutClick = (withLinks, withLinkAndProxy, assets, getProgressOnQuery, closeContextMenu=()=>{}) => {
  let checkoutController = new CheckoutController(
    assets,
    withLinks,
    withLinkAndProxy,
    getProgressOnQuery
  );
    checkoutController.run();
  closeContextMenu();
}

const onUpdateClick = (assets, closeContextMenu=()=>{}) => {
  let { localPaths } = filterAssets(assets, -1, false, false, true);
  NativeActionUtil.runExecQuery(localPaths, 'update');
  closeContextMenu();
};

const onConflictResolveClick = (assets, closeContextMenu=()=>{}) => {
  let { localPaths } = filterAssets(assets, -1, false, false, true);
  NativeActionUtil.runExecQuery(localPaths, 'update');
  closeContextMenu();
};

const onCheckInClick = (assets, closeContextMenu=()=>{}) => {
  let { localPaths } = filterAssets(assets, -1, false, false, true);
  NativeActionUtil.runExecQuery(localPaths, 'commit');
  closeContextMenu();
};